// extracted by mini-css-extract-plugin
module.exports = {"Footer":"SingleFooter__Footer--14-OJ","logoText":"SingleFooter__logoText--2_bEU","logoImg":"SingleFooter__logoImg--TkThK","copyRight":"SingleFooter__copyRight--3sBs2"};